
import getGPAColor from './getGPAColor.js';
const chartOptions = {
  maintainAspectRatio: false,
  responsive: true,
  aspectRatio: 4,
  animation: false,
  layout: { padding: { top: 8, right: 12, bottom: 8, left: 12 } },
  color: "#fff",
  backgroundColor: "rgba(195,195,195,0.92)",

  // ✅ put segment under options.datasets.line so it applies to all line datasets
 datasets: {
  line: {
    borderWidth: 3,
    tension: 0.3,
    borderJoinStyle: 'round',
    borderCapStyle: 'round',
  }
},

  elements: {
    line: {
      borderWidth: 3,
      tension: 0.3,
      borderJoinStyle: 'round',
      borderCapStyle: 'round'
      // ⚠️ do NOT set borderColor here; the segment callback controls it
    },
    point: {
      radius: 4,
      hoverRadius: 6,
      borderWidth: 1,
      borderColor: 'rgba(226,232,240,0.6)',
      backgroundColor: 'rgba(226,232,240,0.15)'
    }
  },

  plugins: {
    legend: {
      display: true,
      labels: {
        color: "#fff",
        usePointStyle: true,
        pointStyle: "circle",
        font: { family: "Inter, ui-sans-serif, system-ui", size: 12 },
        padding: 16
      }
    },
    tooltip: {
      enabled: true,
      backgroundColor: "rgba(17,24,39,0.92)",
      titleColor: "#fff",
      bodyColor: "#fff",
      borderColor: "rgba(148,163,184,0.25)",
      borderWidth: 1,
      padding: 10,
      displayColors: false,
      intersect: false,
      mode: "index"
    },
    datalabels: {
      anchor: "center",
      align: "top",
      color: (ctx) => {
        const v = Number(ctx.dataset.data[ctx.dataIndex]);
        return getGPAColor(v) || "#f5f5f5";
      },
      font: { size: 11, family: "Inter, ui-sans-serif, system-ui", weight: "600" },
      offset: 6,
      borderRadius: 4,
      backgroundColor: "rgba(2,6,23,0.35)",
      padding: { left: 6, right: 6, top: 3, bottom: 3 },
      formatter: (v) => (typeof v === "number" ? v.toFixed(2) : v)
    }
  },

  elements: {
    point: {
      radius: 4,
      hoverRadius: 6,
      borderWidth: 1,
      borderColor: "rgba(226,232,240,0.6)",
      backgroundColor: "rgba(226,232,240,0.15)"
    }
  },

  interaction: { mode: "index", intersect: false },

  scales: {
    x: {
      grid: { color: "rgba(148,163,184,0.15)", borderColor: "rgba(148,163,184,0.35)", tickLength: 4 },
      ticks: { color: "#fff", font: { size: 11 } }
    },
    y: {
      min: 0, max: 4.5, position: "right",
      grid: { color: "#f8f8f8", borderColor: "rgba(148,163,184,0.35)", tickLength: 0 },
      ticks: {
        color: "#fff",
        font: { size: 11 },
        callback: (v) => (Number.isFinite(v) && v.toFixed ? v.toFixed(1) : v)
      }
    },
    y1: { min: 0, max: 4.5, position: "left", grid: { display: false }, ticks: { color: "#fff", font: { size: 11 } } }
  }
};


  var chartOptionsMega = {
    scales: {
      x: {
        ticks: { color: '#fff' },
        grid: { display: false },
        border: { display: false }
      },
      y: {
        ticks: { color: '#fff' },
        grid: { display: false },
        border: { display: false }
      }
    },
  
    interaction: { mode: "nearest", intersect: true },
  
    plugins: {
      legend: {
        labels: { color: '#fff' }
      },
      tooltip: {
        enabled: true,
        callbacks: {
          label: (ctx) => (ctx.parsed.y).toFixed(2) + ""
        }
      },
      // keep labels as you had them (if you want them always visible)
      datalabels: {
        display: true,
        color: '#fff',
        anchor: 'end',
        align: 'top',
        offset: 6,
        clip: true,
        font: { size: 11, weight: 'bold' },
        formatter: (value, ctx) => {
          const v = ctx.parsed?.y ?? value;
          return typeof v === 'number' ? v.toFixed(2) + '' : value;
        }
      }
    },
  
    elements: {
      // Color each point by its value using getGPAColor
      point: {
        radius: 4,
        hoverRadius: 6,
        hitRadius: 8,
        backgroundColor: (ctx) => {
          const v = Number(ctx.parsed?.y ?? ctx.raw);
          return getGPAColor(v);
        },
        borderColor: (ctx) => {
          const v = Number(ctx.parsed?.y ?? ctx.raw);
          return getGPAColor(v);
        },
        borderWidth: 2,
        pointStyle: 'circle'
      },
      // Keep line color simple/neutral (dots carry the meaning)
      line: {
        borderWidth: 3,
        borderColor: '#f8f8f8',
        fill: false,
        tension: 0.25
      },
      // Bars unchanged (optional)
      bar: {
        borderWidth: 0,
        backgroundColor: 'rgba(248,248,248,0.9)'
      }
    }
  };

  

  
  var statisticsChartOptions = {
    responsive: true,
    aspectRatio: 3.5,
    animation: { duration: 800, easing: "easeOutQuart" },
  
    // Hide ticks, labels, grid, and axis borders
    scales: {
      x: {
        ticks: { color: '#fff' },
        grid: { display: false },
        border: { display: false }
      },
      y: {
        ticks: { color: '#fff' },
        grid: { display: false },
        border: { display: false },
        min: 0
      }
    },
  
    // Interactions: hover nearest point/bar only
    interaction: { mode: "nearest", intersect: true },
  
    plugins: {
      legend: { color: '#fff' },
      tooltip: {
        enabled: true,
        callbacks: {
          // Show percentage in tooltip if your data is 0..1
          label: (ctx) =>
            (ctx.parsed.y * 100).toFixed(1) + "%"
        }
      },
      // Ensure datalabels never render on the chart
      datalabels: { display: false }
    },
  
    elements: {
      // Hide default points; glow will show on hover
      point: {
        radius: 0,
        hoverRadius: 0,
        backgroundColor: "#fff",
        borderWidth: 0
      },
      // Simple bright line; no fill
      line: {
        borderWidth: 3,
        borderColor: "#f8f8f8",
        fill: false,
        tension: 0.25,
        callbacks: {
            borderColor: (ctx) => getGPAColor((ctx.parsed.y).toFixed(2))
        }
      },
      // Minimal bars; keep them light
      bar: {
        borderWidth: 0,
        backgroundColor: "rgba(248,248,248,0.9)"
      }
    }
  };
  
export { chartOptions, chartOptionsMega, statisticsChartOptions };